import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { UpdateLLMConversationMutation } from "../API";
import { updateLLMConversation } from "../graphql/mutations";

export async function updateLLMConversationSummary(
  id: string,
  status: string,
  summary: string,
  title: string
): Promise<GraphQLResult<UpdateLLMConversationMutation>> {

  return API.graphql(
    graphqlOperation(updateLLMConversation, {
      input: {
        id: id,
        status: status,
        summary: summary,
        title: title
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMConversationMutation>>;
}
